import { FC } from "react";
import { Button, createStyles, makeStyles } from "@material-ui/core";

import theme from "theme";

const useStyles = makeStyles(() =>
  createStyles({
    resetButton: {
      color: theme.custom.palette.purple.main,
      fontWeight: theme.typography.fontWeightLight,
      padding: 0,
      "&:hover": {
        backgroundColor: theme.custom.palette.purple.light,
      },
    },
  }),
);

interface ResetButtonProps {
  disabled: boolean;
  handleReset: () => void;
}

const ResetButton: FC<ResetButtonProps> = ({ disabled, handleReset }) => {
  const classes = useStyles();
  return (
    <Button
      disabled={disabled}
      className={classes.resetButton}
      onClick={handleReset}
    >
      Reset
    </Button>
  );
};

export default ResetButton;
